<template>
  <div class="position-relative h-100 w-100" v-observe-visibility="observeVisibility">
    <div class="vis-blockly">
      <vis-blockly-component v-if="ready" :options="options" ref="blockly_ref" />
    </div>
    <div class="vis-blockly-code p-3">
      <b-btn @click="showCode" class="mb-3" variant="primary">Code</b-btn>
      <pre class="p-3">{{code}}</pre>
    </div>
  </div>
</template>

<script>
import Blockly from "blockly";
import ruMsg from "blockly/msg/ru";
import initCSharp from "./csharp";
import VisBlocklyComponent from "./vis-blockly-component.vue";
import baseToolbox from "./toolbox";
import theme from "./theme";

export default {
  name: "vue-blockly",
  components: { VisBlocklyComponent },

  data() {
    return {
      ready: false,

      observeVisibility: {
        callback: this.visibilityChanged,
        throttle: 1000,
        throttleOptions: { leading: "visible" },
        once: true
      },

      code: "",
      options: {
        grid: {
          spacing: 25,
          length: 3,
          colour: "#ccc",
          snap: true
        },
        toolbox: `
<xml>
  ${baseToolbox.time}
  ${baseToolbox.date}
  ${baseToolbox.datetime}
  ${baseToolbox.logic}
  ${baseToolbox.math}
  ${baseToolbox.text}
  ${baseToolbox.lists}
  ${baseToolbox.loops}
  ${baseToolbox.vars}
</xml>`,
        _toggled: true
      }
    };
  },

  methods: {
    visibilityChanged(visible) {
      if (visible) this.ready = true;
    },

    showCode() {
      this.code = Blockly.CSharp.workspaceToCode(
        this.$refs.blockly_ref.workspace
      );
    }
  },

  created() {
    Blockly.Themes.Visary = new Blockly.Theme(
      "visary",
      theme.blockStyles,
      theme.categoryStyles,
      theme.componentStyles
    );
    Blockly.Themes.Visary.setFontStyle(theme.fontStyle);
    this.options.theme = Blockly.Themes.Visary;

    Blockly.setLocale(ruMsg);

    //todo: custom renderer
    let zelosCP = Blockly.zelos.ConstantProvider;
    zelosCP.prototype.makeHexagonal = zelosCP.prototype.makeSquared;
    zelosCP.prototype.makeRounded = zelosCP.prototype.makeSquared;

    let imageMx = Blockly.Constants.Text.QUOTE_IMAGE_MIXIN;
    imageMx.newQuote_ = () => " ";

    Blockly.ContextMenu.blockHelpOption = function() {
      return {
        enabled: false,
        text: ""
      };
    };

    initCSharp(Blockly);
  }
};
</script>

<style scoped>
.vis-blockly {
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
}

.vis-blockly >>> .blocklyScrollbarVertical[display="none"] {
  display: none;
}

.vis-blockly-code {
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  height: 100%;
  margin: 0;
  background-color: white;
  z-index: 10020;
}

.vis-blockly-code pre {
  background-color: beige;
}
</style>
